var map = {
	"./bank-transfer.svg": 826,
	"./betnearn-ico.svg": 827,
	"./birthday-bonus-ico.svg": 828,
	"./birthday.svg": 829,
	"./bonus-code-ico.svg": 830,
	"./bonus-ico.svg": 831,
	"./bonus-received-ico.svg": 832,
	"./bonus.svg": 833,
	"./business-account-upgrade-ico.svg": 834,
	"./check-in-daily-ico.svg": 835,
	"./checked.svg": 836,
	"./cloud-pointer.svg": 837,
	"./coin.svg": 838,
	"./crypto.svg": 839,
	"./daily-bonus-ico.svg": 840,
	"./daily-limit.svg": 841,
	"./deposit-delay-bonus-ico.svg": 842,
	"./e-wallet.svg": 843,
	"./earn-x33-coin-ico.svg": 844,
	"./email.svg": 845,
	"./facebook.svg": 846,
	"./feedback.svg": 847,
	"./first-bet-ico.svg": 848,
	"./games-rebate-ico.svg": 849,
	"./info.svg": 850,
	"./instagram.svg": 851,
	"./instant-rebate.svg": 852,
	"./live-casino-rebate-ico.svg": 853,
	"./lucky-spin-ico.svg": 854,
	"./messenger.svg": 855,
	"./mobile-app-deposit-ico.svg": 856,
	"./monthly-cash.svg": 857,
	"./msg-activity.svg": 858,
	"./msg-ann.svg": 859,
	"./msg-notice.svg": 860,
	"./new-icon.svg": 861,
	"./people-ico.svg": 862,
	"./quick-pay.svg": 863,
	"./rescue-bonus-ico.svg": 864,
	"./rescue-lc-ico.svg": 865,
	"./rescue-slots-ico.svg": 866,
	"./return.svg": 867,
	"./sc-bc-active-ico.svg": 868,
	"./sc-bc-ico.svg": 869,
	"./sc-bi-active-ico.svg": 870,
	"./sc-bi-ico.svg": 871,
	"./sc-mail-active-ico.svg": 872,
	"./sc-mail-ico.svg": 873,
	"./sc-mp-active-ico.svg": 874,
	"./sc-mp-ico.svg": 875,
	"./sc-pin-active-ico.svg": 876,
	"./sc-pin-ico.svg": 877,
	"./slots-rebate-ico.svg": 878,
	"./sms.svg": 879,
	"./sports-rebate-ico.svg": 880,
	"./telegram.svg": 881,
	"./twitter.svg": 882,
	"./vip-up-level-ico.svg": 883,
	"./vip-weekly-bonus.svg": 884,
	"./wallet-balance-interest-ico.svg": 885,
	"./wallet-ico.svg": 886,
	"./weekly-tournament-ico.svg": 887,
	"./welcome-bonus-188-ico.svg": 888,
	"./welcome-bonus-ico.svg": 889,
	"./whatsapp-original.svg": 890,
	"./whatsapp.svg": 891,
	"./withdrawal-delay-bonus-ico.svg": 892,
	"./withdrawal.svg": 893,
	"./x33-coin.svg": 894
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1928;